var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.585 16h-7.17A4.42 4.42 0 010 11.585v-7.17A4.42 4.42 0 014.415 0h7.17A4.42 4.42 0 0116 4.415v7.17A4.42 4.42 0 0111.585 16zm2.995-4.415v-7.17a2.999 2.999 0 00-2.995-2.995h-7.17a3 3 0 00-2.993 2.995v7.17a2.999 2.999 0 002.996 2.995h7.17a2.999 2.999 0 002.995-2.995h-.003zm-2.284-6.83a1.04 1.04 0 110-2.081 1.04 1.04 0 010 2.082zM8 12.124a4.123 4.123 0 110-8.246 4.123 4.123 0 010 8.246zm0-6.826a2.703 2.703 0 100 5.406 2.703 2.703 0 000-5.406z",
    fill: "#778CA3"
  })));
}
export default SvgInstagram;